import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
import { Input } from '../components/ui/Input';
export function EditPackage() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  return <div className="space-y-4" data-id="element-815" data-mp="1zqs89drqhabr">
      <div className="flex items-center justify-between" data-id="element-816" data-mp="1c0o1wyn5uwh2">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-817" data-mp="1c17jge8wfiuk">
          {isEdit ? 'Edit Package' : 'Add Package'}
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/packages')} data-id="element-818" data-mp="17wzwali3aayg">
          ← Back to Packages
        </Button>
      </div>

      <Card data-id="element-819" data-mp="t83o8og18xxu">
        <CardContent className="pt-6" data-id="element-820" data-mp="t7tzf46q4wtq">
          <form className="space-y-4 max-w-md" data-id="element-821" data-mp="obvanfhhhcss">
            <Input label="Name" defaultValue={isEdit ? 'Starter Bundle' : ''} data-id="element-822" data-mp="o90qzq6anw0f" />
            <div data-id="element-823" data-mp="1cutoqgh6vylf">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-824" data-mp="1ct969p85g63x">
                Package Types
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-full" data-id="element-825" data-mp="1mkd9jrogq2ix">
                <option data-id="element-826" data-mp="1rj6qju2ykbnu">Generic Package</option>
                <option data-id="element-827" data-mp="twr40dvocntf">Preset package</option>
              </select>
            </div>
            <Input label="Total Courses" type="number" defaultValue={isEdit ? '3' : ''} data-id="element-828" data-mp="yv2e8ppvt0c6" />
            <Input label="Price" defaultValue={isEdit ? '99.00' : ''} data-id="element-829" data-mp="13tlzsp0kca40" />
            <Input label="Crossed Price" defaultValue={isEdit ? '149.00' : ''} data-id="element-830" data-mp="17w8z1azkcxb8" />
            <Input label="Position" type="number" defaultValue={isEdit ? '1' : ''} data-id="element-831" data-mp="2f8sn09ry4cs5" />
            <div data-id="element-832" data-mp="2jd0egepsg6u2">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-833" data-mp="k65pgtd0lmgy">
                Publish
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-24" data-id="element-834" data-mp="f69jiokrbkyr">
                <option data-id="element-835" data-mp="t4pzl64ientk">Yes</option>
                <option data-id="element-836" data-mp="o7r86vc8cuz2">No</option>
              </select>
            </div>
            <div className="pt-2" data-id="element-837" data-mp="ierzbihjmn9">
              <Button type="submit" data-id="element-838" data-mp="jgecc4ybvka">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}